<template>
    <div class="action-bar">
        <div class="action-container">
          <div class="content-left">
            <a-dropdown :trigger="['click']"> 
              <h2>
                {{title}}
                <a-icon style="font-size: 18px;" type="down" />
              </h2>
              <a-menu slot="overlay">
                <a-menu-item class="sort-order-menu-item">
                  <a href="javascript:;" @click="selectSort('id', -1)">
                    <span>Created At</span>
                    <span>
                      <a-icon v-show="isSelectedSortOrder('id')" type="check" />
                    </span>
                  </a>
                  
                </a-menu-item>
                <a-menu-item class="sort-order-menu-item">
                  <a href="javascript:;" @click="selectSort('firstname', 1)">
                    <span>First Name</span>
                    <span>
                      <a-icon v-show="isSelectedSortOrder('firstname')" type="check" />
                    </span>
                  </a>
                </a-menu-item>
                <a-menu-item class="sort-order-menu-item">
                  <a href="javascript:;" @click="selectSort('lastname', 1)">
                    <span>Last Name</span>
                    <span>
                      <a-icon v-show="isSelectedSortOrder('lastname')" type="check" />
                    </span>
                  </a>
                </a-menu-item>
              </a-menu>
            </a-dropdown> 
          </div>
          <div class="content-right">
              <a class="logout-button" @click="logout">Logout</a>
          </div>
        </div>
        <div class="content-container">
          <div class="content"> 
              <slot/>
          </div>
          <div class="meta">{{appVersion}} | {{lastUpdate}}</div>
        </div>
    </div>
</template>

<script>
import { distanceInWordsToNow, parse } from 'date-fns'

export default {
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      default: ''
    }
  },
  computed: {
    selectedSortOrder () {
      return this.$store.getters.getSortOrder
    },
    isLoading () {
      return this.$store.getters.getIsLoading
    },
    appVersion () {
      return `Version ${this.$store.getters.getApplicationVersion}`
    },
    lastUpdate () {
      if (this.isLoading) {
        return `Syncing ...`
      }

      const lastUpdate = this.$store.getters.getLastUpdated
      if (!lastUpdate) {
        return `Last Sync: ${'n/a'}`
      }
      return `Last Sync: ${distanceInWordsToNow(parse(lastUpdate), {addSuffix: true})}`
    }
  },
  methods: {
    async logout () {
      try {
        await this.$store.dispatch('logout')
        this.$router.push('/login')
      } catch (error) {
        this.$router.push('/login')
      }
    },
    selectSort (property, direction) {
      this.$store.commit('setSortOrder', {
        property: property,
        direction: direction
      })
    },
    isSelectedSortOrder (property) {
      return this.selectedSortOrder && this.selectedSortOrder.property === property
    }
  }

}
</script>

<style scoped>
.action-bar {
    border-bottom: 1px solid #e8e8e8;
}

.action-bar {
    padding: 15px
}

h2 {
  cursor: pointer;
}

.action-container {
	display: -ms-flex;
	display: -webkit-flex;
	display: flex;
  align-items: center;
  justify-items: center;
  padding: 0;
  width: 100%;
  margin-top: 30px;
}


.action-container > div {
	width: 50%;
}

.action-container .content-left,
.action-container .content-right {
    font-size: 16px;
    display: flex;
}

.action-container .content-left {
    justify-items: flex-start;
}

.action-container .content-right {
    justify-items: flex-end;
}

.content {
  display: block;
}

.meta {
  font-size: 10px;
  color: rgba(0,0,0,0.4);
  padding: 5px 0;
}

.logout-button {
  width: 100%;
  text-align: right;
  cursor: pointer;
  padding-bottom: 17px;
}

.sort-order-menu-item {
  width: 200px;
  padding: 10px;
}

.sort-order-menu-item a {
  font-size: 12px;
  text-transform: uppercase;
  display: block
}
.sort-order-menu-item a span {
  display: inline-block;
  width: 160px;
}

</style>

<style>
.sort-order-menu-item .ant-dropdown-menu-item:hover,
.sort-order-menu-item .ant-dropdown-menu-item-active {
  background-color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/ActionBar.vue